module.exports = __webpack_public_path__ + "static/IMG_2381-853530ee4376d2d2891d10128dadf7bd.jpg";